import { IForbiddenErrorConfig } from '../components/Fallback/GenericErrorFallback';

export const CollectionOnlyForbiddenMessage: IForbiddenErrorConfig = {
  title: 'Module Not Available',
  message:
    'Your current plan includes Data Collection and Company Profiles. To access additional modules please contact your account manager to upgrade.',
  showContactSupport: true,
};
